import { render, staticRenderFns } from "./SectionTitleSmall.vue?vue&type=template&id=16dedb0a&scoped=true&"
var script = {}
import style0 from "./SectionTitleSmall.vue?vue&type=style&index=0&id=16dedb0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dedb0a",
  null
  
)

export default component.exports